'use strict';

module.exports = {
    FORMAT_LINK: 'https://github.com/d3/d3-format/tree/v1.4.5#d3-format',
    DATE_FORMAT_LINK: 'https://github.com/d3/d3-time-format/tree/v2.2.3#locale_format'
};
